module.exports = __webpack_public_path__ + "img/_footer06.c3650c01.png";